import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UserContext = createContext(); 

export const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
     const apiUrl = process.env.REACT_APP_API_URL;

        // if (userData) return; // If userData is  already set, skip fetching
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${apiUrl}/users_crud.php?getEmployee=1`, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                });
                    
                if (response.data.location === "field") {
                    setUserData(response.data);
                    navigate('/t');
                    // toast.error("Tech Section", { position: "top-center" });
                } else {
                    setUserData(response.data);
                }
            } catch (error) {
                const isNetworkError =
                error?.code === 'ERR_NETWORK' ||
                error?.message === 'Network Error' ||
                !error?.response;

                if (isNetworkError) {
                console.error('Network error caught in UserProvider:', error);

                localStorage.removeItem('user');
                localStorage.removeItem('token');
                sessionStorage.clear();

                document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
                document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=localhost';

                toast.error('Connection lost. Redirecting to login..', {
                    position: 'top-center',
                });

                navigate('/login?reason=offline');
                return;
                }

                if (error.response?.status === 401) {
                console.warn('Unauthorized - redirecting to login');

                localStorage.removeItem('user');
                localStorage.removeItem('token');
                sessionStorage.clear();

                navigate('/login?reason=unauthorized');
                return;
                }

                console.error('Other error in UserProvider:', error);
                toast.error('Error loading user data.', {
                position: 'top-center',
                });
            }
        };

        fetchUserData();
    }, [navigate]);

    return (
        <UserContext.Provider value={userData}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserData = () => useContext(UserContext);
